import Vue from 'vue';
import Component from 'vue-class-component';
import {Prop} from 'vue-property-decorator';
import {Icon} from '../icon/icon';

require('../../../../icons/checkcircleo.svg');
require('../../../../icons/infocircleo.svg');
require('../../../../icons/exclamationcircleo.svg');
require('../../../../icons/closecircleo.svg');
require('../../../../icons/questioncircleo.svg');

export enum AlertType {
  success = 'success',
  info = 'info',
  warning = 'warning',
  error = 'error',
  question = 'question'
}

@Component({
  template: require('./alert.html'),
  name: 'wc-alert',
  components: {
    'wc-icon':Icon
  }
})
export class Alert extends Vue {

  @Prop({
    default: AlertType.info
  })
  type: AlertType;

  @Prop()
  closable: boolean;

  @Prop()
  showIcon: boolean;

  @Prop()
  banner: boolean;
  
  @Prop()
  message: string;

  @Prop()
  description: string;

  get className() {
    let className = `wc-alert ${this.type} ${this.description || !!this.$slots.default ? 'with-description' : '' } ${this.showIcon ? '' : 'no-icon'} ${this.banner ? 'banner' : ''}`;
    return className;
  }

  get iconName() {
    switch(this.type) {
      case AlertType.success: return 'checkcircleo'; 
      case AlertType.info: return 'infocircleo';
      case AlertType.warning: return 'exclamationcircleo';
      case AlertType.error: return 'closecircleo';
      default: return '';
    }
  }
}




// WEBPACK FOOTER //
// node_modules/wc-lib/src/wc-ui/components/alert/alert.ts